import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Review Slider with Cards Effect
 * Displays 3 cards with navigation and custom styling for previous slides
 */
class ReviewSlider {

	/**
	 * Initialize the review slider
	 */
	constructor() {

		this.slider = document.querySelector( '.js-b-review-slider' );
		this.swiper = null;

		this.initSwiper();

	}

	/**
	 * Initialize Swiper with cards effect
	 */
	initSwiper() {

		if ( ! this.slider ) {

			console.log( 'No slider element found with class .js-b-review-slider' );
			return;

		}

		this.swiper = new Swiper( this.slider, {
			modules: [Navigation],
			grabCursor: true,
			slidesPerView: 1,
			navigation: {
				prevEl: '.js-b-review-slider-prev',
				nextEl: '.js-b-review-slider-next',
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 12,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 10,
				}
			},
			on: {
				/**
				 *
				 */
				init: () => {

					this.addPrevClasses();
					this.handleFullReviewLinks();

				},
				/**
				 *
				 */
				slideChangeTransitionStart: () => {

					this.addPrevClasses();
					this.handleFullReviewLinks();

				}
			}
		} );

	}

	/**
	 * Add classes to 2nd and 3rd previous slides for custom styling
	 * This allows us to show 3 cards total (active + 2 previous)
	 */
	addPrevClasses() {

		if ( ! this.slider ) {

			return;

		}

		// Remove existing custom classes
		const allSlides = this.slider.querySelectorAll( '.swiper-slide' );
		allSlides.forEach( slide => {

			slide.classList.remove( 'swiper-slide-prev-2', 'swiper-slide-prev-3' );

		} );

		// Find active slide and add classes to previous slides
		const activeSlide = this.slider.querySelector( '.swiper-slide-active' );

		if ( ! activeSlide ) {

			return;

		}

		const prev1 = activeSlide.previousElementSibling;
		const prev2 = prev1?.previousElementSibling;
		const prev3 = prev2?.previousElementSibling;

		// Add classes for styling (only if elements exist)
		if ( prev2 ) {

			prev2.classList.add( 'swiper-slide-prev-2' );

		}

		if ( prev3 ) {

			prev3.classList.add( 'swiper-slide-prev-3' );

		}

	}

	/**
	 * Show Full Review button if quote is truncated
	 */
	handleFullReviewLinks() {

		const slides = this.slider.querySelectorAll( '.b-review-slider__slide' );
		slides.forEach( slide => {

			const quote = slide.querySelector( '.b-review-slider__quote' );
			const fullLink = slide.querySelector( '.b-review-slider__full-link' );
			if ( !quote || !fullLink ) {

				return;

			}

			// Remove clamp to measure full height
			const originalLineClamp = quote.style.webkitLineClamp;
			quote.style.webkitLineClamp = 'unset';
			const fullHeight = quote.scrollHeight;
			// Restore clamp
			quote.style.webkitLineClamp = '7';
			const clampHeight = quote.clientHeight;

			// If truncated, show button
			if ( fullHeight > clampHeight + 1 ) { // +1 for rounding

				slide.classList.add( 'has-full-link' );
				fullLink.style.display = '';

			} else {

				slide.classList.remove( 'has-full-link' );
				fullLink.style.display = 'none';

			}

		} );

	}

	/**
	 * Destroy the swiper instance
	 */
	destroy() {

		if ( this.swiper ) {

			this.swiper.destroy( true, true );
			this.swiper = null;

		}

	}

}

export default ReviewSlider;
